export interface UserUpload {
  id: string;
  email: string;
  applicationId: string;
}
